import axios from "axios";

const plainAxios = axios.create();

type GetPresignedUrl = (params: {
	driverId: number;
	fileName: string;
	contentType: string;
}) => Promise<{
	uploadUrl?: string;
	filePath?: string;
} | null>;

type UploadCnhFileParams = {
	file: File;
	driverId: number;
	getPresignedUrl: GetPresignedUrl;
};

export async function uploadCnhFile({
	file,
	driverId,
	getPresignedUrl,
}: UploadCnhFileParams): Promise<string> {
	const presigned = await getPresignedUrl({
		driverId,
		fileName: file.name,
		contentType: file.type,
	});

	if (!presigned) {
		throw new Error("URL de upload inválida");
	}

	const { uploadUrl, filePath } = presigned;

	if (!(uploadUrl && filePath)) {
		throw new Error("URL de upload inválida");
	}

	await plainAxios.put(uploadUrl, file, {
		headers: { "Content-Type": file.type },
	});

	return filePath;
}
